import enrollmentReducer from "./enrollmentReducer";

const enrollmentReducers = {
    enrollment: enrollmentReducer
};

export default enrollmentReducers;